import PublisherActions from '../../../../actions/PublisherActions';
import query from '../../../../helpers/query';
import { removeParams } from '../helpers';

export const actions = {
    getFinanceOperations(state) {
        let params = {
        ...query.parseToSend(state),
        ...removeParams()
        };

        PublisherActions.getFinanceOperations(params);
    },
};
